import React from "react";
import AboutUs from "../../../components/AboutUs/AboutUs";

const AboutUsSection = () => {
  return (
    <div>
      <AboutUs custom />
    </div>
  );
};

export default AboutUsSection;
